import { Twitter, Instagram, Linkedin, Mail, Globe, DollarSign} from 'lucide-react';
import WillgoLogo from '../../WillgoLogo.png';
import LOGO_PLACEHOLDER from "../../LOGO_PLACEHOLDER.jpg";

const Type4FooterCard = (props) => {

    const {
        bookingEngine,
        _company_name,
        _logo_url,
    } = props;

    const styles = {
        footer: {
            backgroundColor: (bookingEngine?.headerBg || '#ffffff'),
            borderTop: '1px solid #e2e8f0',
            padding: '4rem 0 2rem 0',
            marginTop: 'auto',
        },
        footerHeading: {
            fontSize: '0.875rem',
            fontWeight: 800,
            color: (bookingEngine?.greetingsCardTitleColor || '#0f172a'),
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            marginBottom: '1.5rem',
        },
        footerLink: {
            fontSize: '0.875rem',
            color: (bookingEngine?.headerMenuTxtColor || '#64748b'),
            textDecoration: 'none',
            transition: 'color 0.2s ease',
            cursor: 'pointer',
        }
    };

    return <div style={styles.footer}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid justify-center grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                {/* Brand Section */}
                <div className="col-span-1 md:col-span-2 lg:col-span-1">
                    <div className="flex justify-center items-center gap-2 mb-6 cursor-pointer">
                        <div className="rounded-lg flex items-center justify-center">
                            {
                                !bookingEngine?.hideCompanyLogo &&
                                <p style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                                    <img style={{width: 100, height: 100, borderRadius: `${bookingEngine?.headerLogoBorderRadius}%`}} 
                                        src={(_logo_url || LOGO_PLACEHOLDER)}/>
                                </p>
                            }
                        </div>
                        <span style={{color: bookingEngine?.headerCompanyTxtColor}} className="text-lg font-bold text-slate-900 tracking-tight">
                            {
                                !bookingEngine?.hideCompanyName &&
                                <>
                                    {         
                                        _company_name ||
                                        "Business Name"
                                    }
                                </>
                            }
                        </span>
                    </div>
                    <div className="flex justify-center items-center gap-4">
                        <a href="#" style={{backgroundColor: bookingEngine?.actionButtonsBg}} className="p-2 bg-slate-50 rounded-full text-slate-400 hover:text-indigo-600 transition-all">
                            <Twitter style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsIconColor }} /></a>
                        <a href="#" style={{backgroundColor: bookingEngine?.actionButtonsBg}} className="p-2 bg-slate-50 rounded-full text-slate-400 hover:text-indigo-600 transition-all">
                            <Instagram style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsIconColor }} /></a>
                        <a href="#" style={{backgroundColor: bookingEngine?.actionButtonsBg}} className="p-2 bg-slate-50 rounded-full text-slate-400 hover:text-indigo-600 transition-all">
                            <Linkedin style={{ width: "16px", height: "16px", color: bookingEngine?.actionButtonsIconColor }} /></a>
                    </div>
                </div>

                {/* Link Columns */}
                <div>
                    <h4 style={{...styles.footerHeading, textAlign: "center"}}>Explore</h4>
                    <ul style={{textAlign: "center"}} className="space-y-0">
                        <li><a style={styles.footerLink} className="hover:text-indigo-600">Top Destinations</a></li>
                        <li><a style={styles.footerLink} className="hover:text-indigo-600">Travel Guides</a></li>
                    </ul>
                </div>

                <div>
                    <h4 style={{...styles.footerHeading, textAlign: "center"}}>Support</h4>
                    <ul style={{textAlign: "center"}} className="space-y-0">
                        <li><a style={styles.footerLink} className="hover:text-indigo-600">Help Center</a></li>
                        <li><a style={styles.footerLink} className="hover:text-indigo-600">Contact Us</a></li>
                    </ul>
                </div>

                {/* Newsletter Section */}
                <div>
                    <h4 style={{...styles.footerHeading, textAlign: "center"}}>Newsletter</h4>
                    <p style={{textAlign: "center", color: bookingEngine?.headerMenuTxtColor}} className="text-xs text-slate-500 mb-4 font-medium">
                        Get the latest deals and tips straight to your inbox.</p>
                    <div className="flex gap-2">
                        <div className="flex-1 align-center flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
                            <Mail style={{ width: "16px", height: "16px", color: bookingEngine?.headerMenuIconColor }} className="text-slate-400" />
                            <input 
                            type="email" 
                            placeholder="Email address" 
                            className="bg-transparent border-none outline-none text-xs w-full text-slate-900"
                            />
                        </div>
                        <button style={{border: "none", backgroundColor: bookingEngine?.actionButtonsBg, color: bookingEngine?.actionButtonsTxtColor}} className="bg-indigo-600 text-white px-3 py-2 rounded-lg text-xs font-bold hover:bg-indigo-700 transition-all">
                            Join
                        </button>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-8">
                <div className="flex items-center gap-6">
                    <p style={{color: bookingEngine?.greetingsCardSecTextColor}} className="text-[11px] font-bold text-slate-400 uppercase tracking-widest">© {new Date().getFullYear()} {
                            /*!bookingEngine?.hideCompanyName &&*/
                            <>
                                {         
                                    _company_name ||
                                    "Business Name"
                                }
                            </>
                                                                    
                        }</p>
                    <div className="flex items-center gap-4">
                        <a style={styles.footerLink} className="text-[11px] font-bold uppercase hover:text-indigo-600">Privacy</a>
                        <a style={styles.footerLink} className="text-[11px] font-bold uppercase hover:text-indigo-600">Terms</a>
                    </div>
                </div>

                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1.5 px-2 py-1 bg-slate-50 border border-slate-200 rounded-md cursor-pointer hover:bg-slate-100 transition-all">
                        <i style={{ fontSize: 12 }} className="fa-solid fa-globe text-slate-500" />
                        <span className="text-[10px] font-bold text-slate-700">English (US)</span>
                    </div>
                    <div className="flex items-center gap-1.5 px-2 py-1 bg-slate-50 border border-slate-200 rounded-md cursor-pointer hover:bg-slate-100 transition-all">
                        <i style={{ fontSize: 12 }} className="fa-solid fa-dollar text-slate-500" />
                        <span className="text-[10px] font-bold text-slate-700">USD</span>
                    </div>
                </div>

                <div style={{display: "none"}} className="flex items-center">
                    <img src={WillgoLogo} className="h-4" alt="Welldugo Integrations" />
                    <span style={{marginLeft: 10, fontSize: 11, fontWeight: "bolder", color: "rgba(0,0,0,0.5)"}}>
                        Partner's with Welldugo</span>
                </div>
            </div>
        </div>
    </div>
}

export default Type4FooterCard;